<template>
  <v-container pa-2 grid-list-xs fluid background>
    <v-layout row wrap pa-3 >
      <v-flex xs12 style="background-color:#ffffff;border-radius:10px;">
        <v-form ref="form"  style="margin-bottom:5rem">
          <v-layout row wrap pa-4>
             <v-flex xs12 text-xs-center style="margin-top:15px;" >
              <p style=" font-size:20px;padding: 10px 0;">{{$t('menu.ShopSetting')}}</p>
            </v-flex>
            <v-flex xs12  id="img_container">
                <img src="../assets/online-store.png" />
            </v-flex>
           
             <v-flex md4 sm8 xs12 pa-1 offset-md4  >
                   <v-text-field v-model="shopname" :label="$t('shop_name')"  hide-details />
              </v-flex>
             
            <v-flex  offset-md4 md4 sm6 xs12 pa-1 v-if="usercode =='adminsolao' ||is_timeattendance == 1 ">
                  <v-checkbox v-model="Use_timeattendance" :label="`${$t('UseCalculateTimeAttendanceSystem')}`"  @change="changeUse()"></v-checkbox>
            </v-flex>
              <v-flex offset-md4 md4 sm4 xs12  text-xs-center >
              <v-btn color="teal" block class="white--text" @click="saveshop()">
                <p style=" font-size:12px;position: absolute;">{{$t('save')}}</p>
              </v-btn>
            </v-flex>
            </v-layout>
        </v-form>

      </v-flex>
     
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
  Use_timeattendance:false,
  guid:"",
  shopname:"",
  is_timeattendance:0, 
  usercode:"",
  }),
 
  computed: {
    
  },
  created: function() {
      this.guid = localStorage._company_guid;
      this.usercode = localStorage._usercode ;
      this.shopname = localStorage._company_name;
     
      if(localStorage._is_timeattendance == 'null'){
        this.is_timeattendance = 0;
        this.Use_timeattendance = false;
      }else{
        if(localStorage._is_timeattendance == 0){
          this.Use_timeattendance = false;
        }else{
          this.Use_timeattendance = true;
        }
         this.is_timeattendance = localStorage._is_timeattendance;
         
      }
      console.log(this.is_timeattendance)
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
   
    goto(path) {
      this.$router.push("/" + path);
    },
    changeUse(){
      if(this.Use_timeattendance == true){
            this.is_timeattendance = 1;
        }
        else{
            this.is_timeattendance = 0;
        }
        console.log(this.is_timeattendance)
    },
    saveshop(){
        console.log(this.guid)
         console.log(this.shopname)
          console.log(this.is_timeattendance)
        SettingService.updateShopName(this.guid,this.shopname,this.is_timeattendance)
        .then(res=>{
          console.log(res)
        })
        .catch(err=>{
          console.log(err)
        })
    },
    
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  display: block;
}
</style>
